import { View, ViewModel } from "binder";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class UnitSelector extends SelectorBaseViewModel<warehouse>{
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    protected async loadData(): Promise<warehouse[]> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/UnitManipulationServices/GetAllUnits',{
            });
            return result.Warehouses.map(x=>{
                let r = new warehouse(this);
                r.id=x.Id;
                r.title = x.Name;
                return r;
            })
        } catch (ex) {
            console.log(ex);
            return Promise.resolve<warehouse[]>([]);
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class warehouse extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}